import { DEFAULT_COMMODITIES } from './quoteDetailModal.const';

export const handleCommodityChange = (pEquipmentType: string, currentCommodity: string[]) => {
    const commodity = currentCommodity;

    if (commodity && Array.isArray(commodity) && commodity.length > 0) {
        if ((commodity.length === 1 && !DEFAULT_COMMODITIES.includes(commodity[0])) || commodity.length > 1) {
            return [];
        }
    }

    let commodityValue = '';

    switch (pEquipmentType) {
        case 'V':
        case 'K':
            commodityValue = 'Dry Freight';
            break;
        case 'F':
        case 'S':
        case 'I':
        case 'N':
            commodityValue = 'Construction Equipment';
            break;
        case 'R':
            commodityValue = 'Produce (Fresh)';
            break;
        case 'L':
        case 'D':
            commodityValue = 'Machinery';
            break;
        case 'default':
            break;
    }

    if (commodityValue) {
        return [commodityValue];
    }
};
